import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

export function Spinner({ className, label }: { className?: string; label?: string }) {
  return (
    <span role="status" aria-live="polite" className="inline-flex items-center gap-2">
      <Loader2 className={cn('size-4 animate-spin text-[var(--color-primary)]', className)} />
      <span className="sr-only">{label ?? 'Loading'}</span>
    </span>
  )
}
